import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import type { SxProps, Theme } from '@mui/material/styles';
import type { SearchableSelectOption } from './SearchableSelect';

interface SearchableMultiSelectProps {
  label: string;
  value: string[];
  options: SearchableSelectOption[];
  onChange: (value: string[]) => void;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  helperText?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

/** Multi-select sibling of SearchableSelect — kept as its own component rather than adding a
 * `multiple` mode to that one, so the many existing single-select call sites across the app can't
 * regress. Same type-to-filter MUI Autocomplete convention, chips for each selected option. */
export default function SearchableMultiSelect({ label, value, options, onChange, fullWidth, size = 'medium', helperText, disabled, sx }: SearchableMultiSelectProps) {
  const selected = options.filter((o) => value.includes(o.value));

  return (
    <Autocomplete
      multiple
      value={selected}
      onChange={(_, next) => onChange(next.map((o) => o.value))}
      options={options}
      getOptionLabel={(o) => o.label}
      getOptionDisabled={(o) => Boolean(o.disabled)}
      isOptionEqualToValue={(o, v) => o.value === v.value}
      fullWidth={fullWidth}
      size={size}
      disabled={disabled}
      sx={sx}
      renderInput={(params) => <TextField {...params} label={label} helperText={helperText} />}
    />
  );
}
